"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportEntriesSchemaDef = exports.reportJobSchemaDef = exports.ReportJobState = exports.CICustomerType = void 0;
const joi_1 = __importDefault(require("joi"));
const Series_1 = require("./internal/Series");
const constants_1 = require("./constants");
const db_1 = require("./db");
const general_1 = require("./general");
const BusinessUnit_1 = require("./internal/BusinessUnit");
const schemaValidator_1 = require("../util/schemaValidator");
const Qualification_1 = require("./internal/Qualification");
const Component_1 = require("./internal/Component");
const Centre_1 = require("./internal/Centre");
const _1 = require(".");
const external_1 = require("./external");
var CICustomerType;
(function (CICustomerType) {
    CICustomerType["INDEPENDENT_CENTRE"] = "Independent Centre";
    CICustomerType["ASSOCIATE"] = "Associate";
    CICustomerType["ASSOCIATE_CENTRE"] = "Associate Centre";
})(CICustomerType = exports.CICustomerType || (exports.CICustomerType = {}));
var ReportJobState;
(function (ReportJobState) {
    ReportJobState["PENDING"] = "PENDING";
    ReportJobState["RUNNING"] = "RUNNING";
    ReportJobState["FINISHED"] = "FINISHED";
    ReportJobState["ERROR"] = "ERROR";
})(ReportJobState = exports.ReportJobState || (exports.ReportJobState = {}));
exports.reportJobSchemaDef = Object.assign(Object.assign({}, general_1.daoObjSchemaDef), { jobCode: joi_1.default.string(), businessUnit: joi_1.default.string(), series: joi_1.default.number(), seriesName: joi_1.default.string(), reportType: joi_1.default.string(), state: joi_1.default.string(), details: joi_1.default.string(), users: (0, schemaValidator_1.arraySchema)(external_1.UserInfoSchema), s3Key: joi_1.default.string().allow(null).optional() });
exports.reportEntriesSchemaDef = Object.assign(Object.assign({}, general_1.daoObjSchemaDef), { type: joi_1.default.string()
        .valid(constants_1.ReportType.NOT_SUBMITTED_MODERATED, constants_1.ReportType.NOT_SUBMITTED_EXAMINED, constants_1.ReportType.SUBMITTED_MODERATED, constants_1.ReportType.TRAINING, constants_1.ReportType.SUBMITTED_EXAMINED)
        .required(), uniqueKey: joi_1.default.string().required(), groupKey: joi_1.default.string().required(), data: joi_1.default.alternatives().conditional('type', {
        switch: [
            {
                is: constants_1.ReportType.NOT_SUBMITTED_MODERATED,
                then: joi_1.default.object({
                    businessUnit: (0, schemaValidator_1.objectSchema)(BusinessUnit_1.businessUnitSchemaDef).required(),
                    series: (0, schemaValidator_1.objectSchema)({
                        id: Series_1.seriesBaseSchemaDef.id.required(),
                        name: Series_1.seriesBaseSchemaDef.name.required(),
                    }).required(),
                    qualification: (0, schemaValidator_1.objectSchema)(Qualification_1.qualificationMinSchemaDef).required(),
                    assessmentCode: Qualification_1.assessmentSchemaDef.code.required(),
                    componentNumber: Component_1.componentSchemaDef.number.required(),
                    centreId: Centre_1.centreBaseSchemaDef.id.required(),
                    replacementFiles: joi_1.default.boolean().optional(),
                    consortia: joi_1.default.object({
                        partOf: joi_1.default.string().optional().allow(''),
                        otherSchools: joi_1.default.string().optional().allow(''),
                    }).optional(),
                    sampleSubmissionDate: joi_1.default.string().optional().allow(''),
                    customerType: joi_1.default.string()
                        .valid(...Object.values(CICustomerType))
                        .optional(),
                    childCentres: joi_1.default.array().items(joi_1.default.string()).required(),
                    entriesCount: joi_1.default.number().required(),
                    marksInputCount: joi_1.default.number().required(),
                    marksSubmittedCount: joi_1.default.number().required(),
                    absentCount: joi_1.default.number().required(),
                    samplesUploadedNotSubmittedCount: joi_1.default.number().required(),
                    learnersWithSpecConsideration: joi_1.default.array().items(joi_1.default.number()).required(),
                    replacementFilesRequestDate: joi_1.default.string().allow('').optional(),
                    replacementFilesLearners: joi_1.default.array().items(joi_1.default.number()).optional(),
                    resubmitter: joi_1.default.object(_1.resubmitterSectionsSchemaDef),
                    areAllResubmissionsEnabled: joi_1.default.boolean().optional(),
                }).required(),
            },
            {
                is: constants_1.ReportType.NOT_SUBMITTED_EXAMINED,
                then: joi_1.default.object({
                    businessUnit: (0, schemaValidator_1.objectSchema)(BusinessUnit_1.businessUnitSchemaDef).required(),
                    series: (0, schemaValidator_1.objectSchema)({
                        id: Series_1.seriesBaseSchemaDef.id.required(),
                        name: Series_1.seriesBaseSchemaDef.name.required(),
                    }).required(),
                    qualification: (0, schemaValidator_1.objectSchema)(Qualification_1.qualificationMinSchemaDef).required(),
                    assessmentCode: Qualification_1.assessmentSchemaDef.code.required(),
                    componentNumber: Component_1.componentSchemaDef.number.required(),
                    centreId: Centre_1.centreBaseSchemaDef.id.required(),
                    resubmitter: joi_1.default.object(_1.resubmitterSectionsSchemaDef),
                    replacementFiles: joi_1.default.boolean().optional(),
                    replacementFilesRequestDate: joi_1.default.string().allow('').optional(),
                    learner: joi_1.default.object({
                        number: db_1.learnerDef.number.required(),
                        name: db_1.learnerDef.name.required(),
                    }).required(),
                }).required(),
            },
            {
                is: constants_1.ReportType.SUBMITTED_MODERATED,
                then: joi_1.default.object({
                    entry: joi_1.default.object(db_1.entryDef).required(),
                    series: (0, schemaValidator_1.objectSchema)({
                        id: Series_1.seriesBaseSchemaDef.id.required(),
                        name: Series_1.seriesBaseSchemaDef.name.required(),
                    }).required(),
                    qualification: joi_1.default.object(Qualification_1.qualificationMinSchemaDef).required(),
                    consortia: joi_1.default.object(_1.consortiumSchemaDef).optional(),
                    parentCentre: joi_1.default.object({
                        id: joi_1.default.string().required(),
                        name: joi_1.default.string().required(),
                    }).optional(),
                    moderatorApportioned: joi_1.default.object({
                        name: joi_1.default.string().allow('').required(),
                        examinerNumber: joi_1.default.string().allow('').required(),
                    }).required(),
                    allSectionsSubmitted: joi_1.default.boolean().required(),
                    allSectionsMissing: joi_1.default.boolean().required(),
                    partialSubmission: joi_1.default.boolean().required(),
                    missingSections: joi_1.default.array().items(joi_1.default.string()).required(),
                    selectedInSample: joi_1.default.boolean().required(),
                    submissionDate: joi_1.default.string().optional().allow(''),
                }).required(),
            },
            {
                is: constants_1.ReportType.TRAINING,
                then: joi_1.default.object({
                    learnerBid: external_1.learnerBusinessId,
                    seriesName: joi_1.default.string().required(),
                    qualificationName: joi_1.default.string().required(),
                    sections: joi_1.default.array().items(joi_1.default.string()).required(),
                    learnerName: joi_1.default.string().required(),
                }).required(),
            },
            {
                is: constants_1.ReportType.SUBMITTED_EXAMINED,
                then: joi_1.default.object({
                    learnerBid: external_1.learnerBusinessId,
                    seriesName: joi_1.default.string().required(),
                    qualificationName: joi_1.default.string().required(),
                    learnerName: joi_1.default.string().required(),
                    businessUnit: (0, schemaValidator_1.objectSchema)(BusinessUnit_1.businessUnitSchemaDef).required(),
                    allFilesSubmitted: joi_1.default.boolean().required(),
                    partialSubmission: joi_1.default.boolean().required(),
                    markedAsAbsent: joi_1.default.boolean().required(),
                    missingSections: joi_1.default.array().items(joi_1.default.string()).required(),
                    submissionDate: joi_1.default.string().optional(),
                }).required(),
            },
        ],
    }) });
